module.exports = __webpack_public_path__ + "static/media/eComicSR-02_2x.fb475e88.png";